import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack';
import { TextField, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress, Grid, InputAdornment } from '@material-ui/core';
import { DeletePopUp, EmptyCollection, PageLoader, Pagination, RevisionHistory, SortableHeaderCell, STableLoader } from '../../../shared_elements'
import { globalGetService, globalPutService, globalPostService, globalDeleteService } from '../../../../globalServices';
import { checkApiStatus, checkPermission } from '../../../utils_v2';
import EditIcon from '@material-ui/icons/Edit';
import ConfigSideNav from '../../../config/components/ConfigSideNav';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { Autocomplete } from '@material-ui/lab';
import ReadMoreInline from '../../../../shared/components/ReadMoreInline';
import ConfigData from '../../master/components/ConfigData';
import AddIcon from '@material-ui/icons/Add';
import { usePageTitleOffset } from '../../../elements/CollapsibleSideNav';
const AddNewSTCsMods = ({ addEditLessee, toggleModalFn, getResponseBack, aircraftTypes }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [stcData, setStcData] = useState(addEditLessee.data);
    const onFieldChange = (key, value) => {
        setStcData({
            ...stcData,
            [key]:value
        })
    }

    const onSave = () => {
        let validateInput = {}
        validateInput = {
            ...validateInput,
            name: stcData?.name?.trim() ? '' : 'Please enter Name',
            aircraft_types: stcData?.aircraft_types?.length ? '' : 'Please select Aircraft Types'
        }
        if (Object.keys(validateInput).every(item => validateInput[item] === '')) {
            setLoading(true)
            let payload = Object.assign({}, stcData)
            if (payload?.id) {
                payload={
                    name: payload.name,
                    aircraft_types: payload.aircraft_types || null
                }
                globalPutService(`config-data/stc-mod/${stcData.id}/`, payload)
                .then(response => {
                        setLoading(false)
                        if (checkApiStatus(response)) {
                            toggleModalFn()
                            getResponseBack()
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
                        }
                    })
            } else {
                globalPostService(`config-data/stc-mod/`, payload)
                    .then(response => {
                        setLoading(false)
                        if (checkApiStatus(response)) {
                            toggleModalFn()
                            getResponseBack()
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
                        }
                    })
            }
        } else{
            setError(validateInput)
        }
    }
    
    return (
        <Dialog
            open={addEditLessee.modal}
            className='console-management-modal add-edit-role-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
               {addEditLessee?.type =='edit'?'Edit':'Add'} STC & Mods
            </DialogTitle>
            <DialogContent dividers={true} style={{width:"500px"}}>
                <div>
                    <Grid container>
                        <Grid item md={12}>
                            <TextField
                                required
                                id='sequence'
                                label='STC Name'
                                value={stcData?.name || ''}
                                fullWidth
                                margin="normal"
                                onChange={(e) =>onFieldChange('name', e.target.value) }
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                error={error?.name || ''}
                                helperText={error?.name || ''}
                                onFocus={() => setError({ ...error, name: '' })}
                            />
                        </Grid>
                        <Grid item md='12'>
                            <Autocomplete 
                            disableCloseOnSelect
                            options={aircraftTypes}
                            multiple={true}
                            getOptionSelected={(option, value) => option.id === value.id}
                            getOptionLabel={option=>option.name}
                            value={stcData?.aircraft_types}
                            onChange={(e,value)=> onFieldChange('aircraft_types',value)}
                            renderInput={params =>
                                <TextField required {...params} error={error?.aircraft_types || ''}  helperText={error?.aircraft_types || ''}  onFocus={() => setError({ ...error, aircraft_types: '' })} name='aircraft_types' label='Aircraft Types' fullWidth size='small' InputLabelProps={{ shrink: true }} margin="normal" variant='outlined'
                                />
                            }
                            />
                        </Grid>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button onClick={onSave} disabled={isLoading } color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const STCsMods = ({ }) => {
    const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');
    const [isLoading, setLoading] = useState(false);
    const [addEditLessee, setAddEditSTCsMods] = useState({});
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [stcModsList, setStcModsList] = useState([]);
    const [aircraftTypes, setAircraftTypes] = useState([]);
    const [deleteModal, setDelete] = useState({});
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    useEffect(() => {
        getStcList({ per_page: 50 },'skeletonLoader');
        getAircraftTypes();
    }, []);
    const getStcList = (query, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        // keep the active sort on every refetch (pagination, edit, delete)
        globalGetService(`config-data/stc-mod/`, { ...(sortInfo.sort ? sortInfo : {}), ...query })
            .then(response => {
                if (checkApiStatus(response)) {
                    setStcModsList(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            })
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getStcList({ ...sortQuery, page: 1, per_page: stcModsList?.pagination?.per_page || 50 }, 'pageLoader');
    }
    const getAircraftTypes =()=>{
        globalGetService(`console/aircraft-types/`)
        .then(response=>{
            if(checkApiStatus(response)){
                let aircraftTypeInfo = response.data.data?.aircraftTypes
                const data = aircraftTypeInfo.map(item=> {return {name:item.name, id:item.id}})
                setAircraftTypes(data)
            }
        })
    }   
    const onDelete =()=>{
        setLoading(true)
        globalDeleteService(`config-data/stc-mod/${deleteModal?.data?.id}`)
        .then(response=>{
            setLoading(false)
            if(checkApiStatus(response)){
                setDelete({ modal: false, data: null });
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    getStcList({per_page:stcModsList.pagination?.per_page},'pageLoader');
            }
        })
    }
    return (
        <section className='config-container' style={{ margin: '24px 0 0 75px', }}>
            <Paper className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content" style={{ paddingTop: '10px' }}>
                    {/* <Paper> */}
                        {skeletonLoader ? <STableLoader count={4} size={9} /> :
                            <>
                                <Paper className="console-forms-fields console-paper" style={{ padding: '10px', marginBottom: "2px" }}>
                                    <Grid container>
                                        <Grid item md={6}></Grid>
                                        <Grid item md={6}>
                                            <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                                {checkPermission('config_data', 'stcs_&_mods', 'C') ?
                                                    <li className='list-inline-item'>
                                                        <Button onClick={() => setAddEditSTCsMods({ modal: true })} color='primary' size='small' variant='contained'>
                                                            <AddIcon style={{ fontSize: '1.15rem' }} />  Add New STC
                                                        </Button>
                                                    </li> : null}
                                                <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                                    <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdstcandmod/`} queryParams={{ action: '0,1,2' }} />
                                                </li>
                                            </ul>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                {(() => {
                                    return (<>
                                        <Paper style={{ height: `${window.innerHeight - 210}px`, overflow: 'scroll' }}>
                                            <Table className='mui-table-format' stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, width: '100px' }}>Action(s)</TableCell>
                                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="name" width={'140'}>STC Name</SortableHeaderCell>
                                                        <TableCell>Aircraft Type</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {stcModsList?.list?.map((item, index) =>
                                                        <TableRow key={index}>
                                                            <TableCell align='left' style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1 }}>
                                                                <ul className='list-inline'>
                                                                    <li className='list-inline-item' style={{ cursor: 'pointer' }} onClick={(e) => e.stopPropagation()}>
                                                                        <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdstcandmod/`} queryParams={{ action: '0,1,2', object_id: item?.id }} />
                                                                    </li>
                                                                    {checkPermission('config_data', 'stcs_&_mods', 'U')?
                                                                    <li className='list-inline-item'>
                                                                        <EditIcon style={{ cursor: 'pointer' }} onClick={() => setAddEditSTCsMods({ modal: true, data: item, type: 'edit' })} color='primary' fontSize='small' />
                                                                    </li>:null}
                                                                    {checkPermission('config_data', 'stcs_&_mods', 'D')?
                                                                    <li onClick={()=>setDelete({modal:true, data:item})} className='list-inline-item'>
                                                                        <DeleteOutlineIcon style={{ cursor: 'pointer' }} color='secondary' fontSize='small' />
                                                                    </li>:null}
                                                                </ul>
                                                            </TableCell>
                                                            <TableCell>{item.name || '--'}</TableCell>
                                                            <TableCell>{ <ReadMoreInline chipView={true} maxLength='5' chipText ={item?.aircraft_types} />} </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                            <Paper>
                                                {!stcModsList?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                            </Paper>
                                        </Paper>
                                            <Paper>
                                                <Pagination 
                                                pagination={stcModsList.pagination}
                                                onChangePage={(e, newpage)=>getStcList({page:newpage+1, per_page:stcModsList.pagination?.per_page || 50}) }
                                                onChangeRowsPerPage={(event)=>getStcList({page:1, per_page:event.target.value}) }
                                                />
                                            </Paper>
                                            </>
                                    )
                                })()}
                            </>
                        }
                        {
                            addEditLessee?.modal ?
                                <AddNewSTCsMods
                                    aircraftTypes={aircraftTypes}
                                    addEditLessee={addEditLessee}
                                    getResponseBack={() => getStcList({per_page:stcModsList?.pagination?.per_page},'pageLoader')}
                                    toggleModalFn={() => setAddEditSTCsMods({ modal: false, data: {} })}
                                />
                                : null
                        }
                        {
                            deleteModal?.modal ?
                                <DeletePopUp
                                    modal={deleteModal.modal}
                                    title='Delete STC '
                                    content={`Are you sure, you want to Delete?`}
                                    toggleModalFn={() => setDelete({ modal: false, data: null })}
                                    deleteRecordFn={onDelete}
                                /> : null
                        }
                        {isLoading ? <PageLoader /> : null}
                    {/* </Paper> */}
                </div>
            </Paper>
        </section>
    )
}
export default STCsMods;